import { BaseUseCase } from "./UseCaseBase";
class MarketDataUseCase extends BaseUseCase {
    constructor(repo) {
        super();
        this.repo = repo;
    }
    async fetchResult() {
        return await this.repo.getMarketData();
    }
}
export default MarketDataUseCase;
